import React, { useState, useEffect } from 'react';

const Toast = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onClose(), 300); // Wait for fade out animation
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getToastStyles = () => {
    const baseStyles = {
      padding: '12px 16px',
      borderRadius: '12px',
      fontSize: '14px',
      fontWeight: '600',
      boxShadow: '0 4px 24px rgba(0, 0, 0, 0.15)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between', // Space between content and close button
      gap: '12px',
      minWidth: '300px',
      maxWidth: '90vw',
      animation: isVisible ? 'slideUp 0.3s ease-out' : 'fadeOut 0.3s ease-in forwards',
    };

    switch (type) {
      case 'success':
        return {
          ...baseStyles,
          backgroundColor: '#e8f5e9',
          color: '#1f2937',
          border: '1px solid #c8e6c9'
        };
      case 'error':
        return {
          ...baseStyles,
          backgroundColor: '#fee2e2',
          color: '#991b1b',
          border: '1px solid #fecaca'
        };
      case 'warning':
        return {
          ...baseStyles,
          backgroundColor: '#fffbeb',
          color: '#92400e',
          border: '1px solid #fde68a'
        };
      default:
        return {
          ...baseStyles,
          backgroundColor: '#f3f4f6',
          color: '#1f2937',
          border: '1px solid #e5e7eb'
        };
    }
  };

  const Icon = () => {
    if (type === 'success') {
      return (
        <div style={{
          width: 20, height: 20, borderRadius: '50%', background: '#22c55e',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
        }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
      );
    }
    if (type === 'error') {
      return (
        <div style={{
          width: 20, height: 20, borderRadius: '50%', background: '#ef4444',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
        }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <style>
        {`
          @keyframes slideUp {
            from { transform: translateY(20px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
          @keyframes fadeOut {
            from { opacity: 1; }
            to { opacity: 0; }
          }
        `}
      </style>
      <div style={getToastStyles()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Icon />
          <span>{message}</span>
        </div>
        <button
          onClick={() => { setIsVisible(false); setTimeout(onClose, 300); }}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            padding: 4, display: 'flex', alignItems: 'center', color: 'inherit', opacity: 0.6
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </>
  );
};

export default Toast;
